var window=global;var $CLJS=require("./cljs_env.js");
'use strict';$CLJS.hz=require("ttag");module.exports=$CLJS.hz;